<template>
  <header class="portal-header" :class="{ scrolled: isScrolled }">
    <div class="header-inner container">
      <router-link to="/" class="brand">
        <img src="/favicon.png" alt="笔芯科研" class="brand-icon" />
        <span class="brand-name">笔芯科研</span>
      </router-link>

      <button class="menu-toggle" @click="menuOpen = !menuOpen" aria-label="菜单">
        <i :class="menuOpen ? 'bi bi-x-lg' : 'bi bi-list'"></i>
      </button>

      <nav class="nav-panel" :class="{ open: menuOpen }">
        <div class="nav-links">
          <router-link to="/" exact class="nav-link" @click.native="goHome">功能</router-link>
          <router-link to="/pricing" class="nav-link" @click.native="closeMenu">价格</router-link>
          <router-link to="/faq" class="nav-link" @click.native="closeMenu">常见问题</router-link>
          <router-link to="/about" class="nav-link" @click.native="closeMenu">关于</router-link>
        </div>
        <div class="nav-actions">
          <router-link to="/ppt" class="btn-ppt-header small" @click.native="closeMenu">
            免费PPT生成 <i class="bi bi-easel"></i>
          </router-link>
          <router-link to="/workbench" class="btn-primary small" @click.native="closeMenu">
            马上开始 <i class="bi bi-arrow-right"></i>
          </router-link>
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PortalHeader',
  data() {
    return {
      menuOpen: false,
      isScrolled: false
    }
  },
  mounted() {
    this.onScroll = () => {
      this.isScrolled = window.scrollY > 8
    }
    window.addEventListener('scroll', this.onScroll, { passive: true })
    this.onScroll()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    closeMenu() {
      this.menuOpen = false
    },
    goHome() {
      this.closeMenu()
      if (this.$route.path === '/') {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
.portal-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  height: var(--header-height);
  opacity: 1;
  transform: translateY(0);
  transition:
    box-shadow 0.35s ease,
    background 0.35s ease,
    border-color 0.35s ease;
  background: rgba(255, 255, 255, 0.82);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-bottom: 1px solid rgba(229, 231, 235, 0.9);
}

.portal-header.scrolled {
  background: rgba(255, 255, 255, 0.96);
  border-bottom-color: rgba(25, 118, 210, 0.12);
  box-shadow: 0 4px 24px rgba(25, 118, 210, 0.08);
}

.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  gap: 16px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.brand-icon {
  width: 34px;
  height: 34px;
  object-fit: contain;
  display: block;
  flex-shrink: 0;
  transition: transform 0.35s ease;
}

.brand:hover .brand-icon {
  transform: rotate(-8deg) scale(1.05);
}

.brand-name {
  font-size: 18px;
  font-weight: 600;
}

.menu-toggle {
  display: none;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  color: #4b5563;
  font-size: 22px;
  transition: background 0.2s ease;
}

.menu-toggle:hover {
  background: rgba(25, 118, 210, 0.08);
}

.nav-panel {
  display: flex;
  align-items: center;
  gap: 24px;
  flex: 1;
  justify-content: flex-end;
  min-width: 0;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 24px;
  margin-right: auto;
  margin-left: 40px;
}

.nav-links .nav-link {
  color: #374151;
  font-size: 16px;
  position: relative;
  white-space: nowrap;
  transition: color 0.25s ease;
}

.nav-links .nav-link::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -6px;
  width: 100%;
  height: 2px;
  border-radius: 999px;
  background: var(--primary);
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.3s cubic-bezier(0.22, 1, 0.36, 1);
}

.nav-links .nav-link:hover {
  color: var(--primary);
}

.nav-links .nav-link:hover::after {
  transform: scaleX(1);
}

.nav-links .nav-link.router-link-exact-active {
  color: var(--primary);
}

.nav-links .nav-link.router-link-exact-active::after {
  transform: scaleX(1);
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.link-btn {
  color: var(--text-secondary);
  font-size: 16px;
  white-space: nowrap;
}

.link-btn:hover {
  color: var(--primary);
}

.nav-actions .btn-primary.small {
  height: 38px;
  padding: 0 18px;
  font-size: 15px;
  box-shadow: 0 4px 14px rgba(25, 118, 210, 0.22);
}

.nav-actions .btn-primary.small i {
  transition: transform 0.25s ease;
}

.nav-actions .btn-primary.small:hover i {
  transform: translateX(3px);
}

.btn-ppt-header.small {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 38px;
  padding: 0 16px;
  border-radius: 999px;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

@media (max-width: 960px) {
  .menu-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .nav-panel {
    position: fixed;
    top: var(--header-height);
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
    padding: 20px 24px 24px;
    background: rgba(255, 255, 255, 0.98);
    border-bottom: 1px solid #e5e7eb;
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.06);
    display: none;
    opacity: 0;
    transform: translateY(-8px);
    transition: opacity 0.3s ease, transform 0.3s ease;
  }

  .nav-panel.open {
    display: flex;
    opacity: 1;
    transform: translateY(0);
  }

  .nav-links {
    flex-direction: column;
    align-items: flex-start;
    margin: 0;
    gap: 14px;
  }

  .nav-actions {
    flex-direction: column;
    width: 100%;
  }

  .nav-actions .btn-primary,
  .nav-actions .btn-ppt-header {
    width: 100%;
  }
}
</style>
